<template>
  <div class="row">
    <div class="col-sm-12">
      <h7 style="float: left; font-weight: 500; font-size: 16px"
        >Backup Requests</h7
      >
    </div>
  </div>
  <div class="backup-request-holder mt-1">
    <div>
      <span
        v-for="backupTR in selectedBackupTR"
        :key="backupTR.id"
        class="badge rounded-pill bg-light text-dark backup-tr-badge"
        style="margin-right: 5px; margin-bottom: 5px"
        >{{ backupTR.backup_request_code }}
        <i class="bi bi-x-lg" @click="removeSelectedBackupTR(backupTR.id)"></i
      ></span>
    </div>
    <div
      @click="removeAllSelectedBackupTR()"
      style="font-size: 13px; cursor: pointer; white-space: nowrap"
    >
      Clear All
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedBackupTR: JSON.parse(localStorage.getItem('selectedBackupTR'))
    };
  },
  methods: {
    removeSelectedBackupTR(id) {
      this.selectedBackupTR.forEach((element, index) => {
        if (element.id == id) {
          this.selectedBackupTR.splice(index, 1);
        }
      });
      if (this.selectedBackupTR.length > 0) {
        localStorage.setItem(
          'selectedBackupTR',
          JSON.stringify(this.selectedBackupTR)
        );
        this.$emit('syncBackupTRs', this.selectedBackupTR);
      } else {
        this.removeAllSelectedBackupTR();
      }
    },

    removeAllSelectedBackupTR() {
      localStorage.removeItem('selectedBackupTR');
      localStorage.removeItem('searchDriverFromPartnerPage');
      this.selectedBackupTR = null;
      this.$emit('syncBackupTRs', this.selectedBackupTR);
    }
  }
};
</script>

<style scoped>
.backup-tr-badge {
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
}
.backup-request-holder {
  display: flex;
  justify-content: space-between;
}
</style>
